/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Preferences_Channel_PushInputs */

const de_notifications_preferences_channel_push = /** @type {(inputs: Notifications_Preferences_Channel_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push`)
};

/** @type {(inputs: Notifications_Preferences_Channel_PushInputs) => LocalizedString} */
const en_notifications_preferences_channel_push = de_notifications_preferences_channel_push;

/**

* @param {Notifications_Preferences_Channel_PushInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_preferences_channel_push = /** @type {((inputs?: Notifications_Preferences_Channel_PushInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Preferences_Channel_PushInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_preferences_channel_push(inputs)
	return en_notifications_preferences_channel_push(inputs)
});